import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box, Notification } from "grommet";
import { announcementService } from "../../services/announcement";

const DISMISSED_KEY = "dismissed-announcements";
// include updated_at so an edited announcement is shown again
const dismissKey = (a) => `${a.id}:${a.updated_at}`;
const readDismissed = () => {
    try {
        return JSON.parse(sessionStorage.getItem(DISMISSED_KEY)) || [];
    } catch {
        return [];
    }
};

export const AnnouncementBanner = () => {
    const access = useSelector((state) => state.session.user && state.session.user.access);
    const [announcements, setAnnouncements] = useState([]);
    const [dismissed, setDismissed] = useState(readDismissed);

    useEffect(() => {
        if (!access) return undefined;
        let cancelled = false;
        announcementService.getActiveAnnouncements(access)
            .then((data) => { if (!cancelled) setAnnouncements(Array.isArray(data) ? data : []); })
            .catch(() => { if (!cancelled) setAnnouncements([]); });
        return () => { cancelled = true; };
    }, [access]);

    const now = new Date();
    const visible = announcements.filter(
        (a) => !(a.end_date && new Date(a.end_date) < now) && !dismissed.includes(dismissKey(a))
    );
    if (visible.length === 0) return null;

    const dismiss = (a) => {
        const next = [...dismissed, dismissKey(a)];
        setDismissed(next);
        try {
            sessionStorage.setItem(DISMISSED_KEY, JSON.stringify(next));
        } catch { /* storage unavailable: dismissal lasts until reload */ }
    };

    return (
        <Box flex={false}>
            {visible.map((a) => (
                <Notification key={a.id} global status="info" title={a.title} message={a.description} onClose={() => dismiss(a)} />
            ))}
        </Box>
    );
};
